import { api } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';

export default {
   async get({
      squad_id,
      candidate_pool_id,
      page,
      per_page,
      date_between,
      candidate_filter,
      search,
      cancelToken,
      include_all_slots,
      with_slots_sum_seconds_planned,
      without_trashed_candidate_pools,
      with_no_overlapping_slots,
      includes,
   }: {
      squad_id?: number;
      candidate_pool_id?: number;
      page: number;
      per_page: number;
      date_between?: string;
      candidate_filter?: string;
      search?: string;
      cancelToken?: CancelToken;
      include_all_slots?: boolean;
      with_slots_sum_seconds_planned?: boolean;
      without_trashed_candidate_pools?: boolean;
      with_no_overlapping_slots?: number;
      includes?: string;
   }) {
      if (include_all_slots && candidate_filter) {
         candidate_filter = `${candidate_filter}&except_having_slots_between=${date_between}&except_having_slots_for_squad_id=${squad_id}`;
      }

      return await api
         .get('/candidate-pool-squad', {
            params: {
               'filter[availabilities_between]': date_between,
               'filter[candidate_filter]': candidate_filter,
               'filter[search]': search,
               'filter[squad_id]': squad_id,
               'filter[candidate_pool_id]': candidate_pool_id,
               'filter[with_slots_sum_seconds_planned]:': with_slots_sum_seconds_planned,
               'filter[without_trashed_candidate_pools]': without_trashed_candidate_pools,
               'filter[with_no_overlapping_slots]': with_no_overlapping_slots,
               page,
               per_page,
               include:
                  includes ??
                  'candidate_pool.candidate,candidate_pool.candidate.language,candidate_pool.candidate.tenant,candidate_pool.pool,candidate_pool.candidate.candidate_activation_state',
            },
            cancelToken,
         })
         .then((response) => {
            return response?.data;
         });
   },

   async getById(id: number, cancelToken: CancelToken) {
      return await api
         .get(`candidate-pool-squad/${id}`, {
            params: {
               include:
                  'candidate_pool.candidate,candidate_pool.default_squad,candidate_pool.candidate.parameters.parameter_type,candidate_pool.candidate.tenant,candidate_pool.candidate.user.latest_user_activity,candidate_pool.pool,candidate_pool.all_tags.tag_type,candidate_pool.candidate.language',
            },
            cancelToken,
         })
         .then((response) => response?.data);
   },
};
